"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactComponents = require("@ui-propulsion/react-components");
var useStyles = (0, _reactComponents.makeStylesPropulsion)(function (theme) {
  var palette = theme.palette,
    typography = theme.typography;
  var fontFamilyRegular = typography.fontFamilyRegular,
    fontFamilyMedium = typography.fontFamilyMedium,
    pxToRem = typography.pxToRem;
  return {
    root: {
      fontSize: pxToRem(12),
      fontFamily: fontFamilyRegular,
      lineHeight: pxToRem(20),
      color: palette.sapphire[900],
      '& a': {
        fontFamily: fontFamilyMedium,
        color: palette.sapphire[500],
        textDecoration: 'none',
        cursor: 'pointer'
      }
    }
  };
}, {
  name: 'PlaidReselectBankAccount'
});
exports.useStyles = useStyles;
